// Renders a (possibly) HTML string coming from the backend. Report text fields
// (syndicator_summary, run_way, investment_events) can arrive either as plain
// text ("русский") or HTML-wrapped ("<p>русский</p>"). Rendering as plain React
// children would show the raw tags, so we inject them as markup — same approach
// as recordHtmlParagraph for deal fields. Value is expected to be an already
// localized string (see normalizeReportForDisplay).
export const HtmlText = ({ value, ...props }) => (
	<span {...props} dangerouslySetInnerHTML={{ __html: value ?? '' }} />
)

export default HtmlText
